import { addCommas } from "@persian-tools/persian-tools";

export default function ReportCard({ array }) {
  return array?.map((value) => (
    <div className="col-12 col-sm-6  flex-grow-1 ">
      <div
        className={`text-center  color-wh-01 py-3 m-1 rounded ${value?.customClass}`}
      >
        <div className="font-14-400">{value?.title}</div>
        {value?.value != "" && (
          <div className="font-16-700 letter-spacing-2">{value?.value}</div>
        )}
      </div>
    </div>
  ));
}
